import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import "./App.css";
import Cases from "./components/Cases";
import Contato from "./components/Contato";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import SobreNos from "./components/SobreNos";
import Solucoes from "./components/Solucoes";
import VSL from "./components/VSL";
import Conversao from "./components/Conversao";
import SplashScreen from "./components/SplashScreen";

function App() {
  

  useEffect(() => {
    AOS.init({ duration: 700, easing: "ease-in-out", once: true });

    
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <VSL />
      <Conversao />
      <SobreNos />
      <Solucoes />
      <Cases />
      <FAQ />
      <Contato />
      <Footer />
      <SplashScreen />
    </div>
  );
}

export default App;
